import type { CenterLayerApiResponse } from '@/domains/centerLayer/centerLayer.entity';
import type { CenterLayerRepository } from '@/domains/centerLayer/centerLayer.repository';
import type { Center } from '@/domains/shared';
import { centerLayerApiService } from '../http/centerLayer.api';

/**
 * Repositorio de datos de capa de centro con operaciones de lectura
 * Cumple con ISP: interfaz segregada solo para obtención de datos
 */
class CenterLayerApiRepository implements CenterLayerRepository {
  /**
   * Obtiene datos completos de un centro específico desde la API
   * @param center - Código o identificador del centro educativo
   */
  async getCenterLayer(center: Center): Promise<CenterLayerApiResponse> {
    const centerLayerResponse =
      await centerLayerApiService.getCenterLayer(center);

    if (!centerLayerResponse)
      throw new Error('Error al obtener los datos de centerLayer');

    return centerLayerResponse;
  }
}

export const centerLayerApiRepository = new CenterLayerApiRepository();
